<template>
  <v-app-bar app clipped-left>
    <v-app-bar-nav-icon @click.stop="$emit('handleDrawer')">

    </v-app-bar-nav-icon>
    <v-toolbar-title style="width: 200px" class="ml-0 pl-4">
      <span class="hidden-sm-and-down">Oil terminal</span>
    </v-toolbar-title>
    <h4 class="hidden-sm-and-down">{{ seller.CompanyName }}</h4>
    <v-spacer></v-spacer>
    <div style="width: 500px;">
      <v-text-field
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="ПОИСК"
          class="hidden-sm-and-down"
      ></v-text-field>
    </div>
    <v-spacer></v-spacer>

    <h4>{{ user.name }}</h4>

    <v-spacer></v-spacer>
    <v-btn @click="handleTheme" class="mr-3" icon>
      <v-icon>
        {{
          theme !== 'dark' ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'
        }}
      </v-icon>
    </v-btn>
    <v-menu
        offset-y
        left
        bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            icon
            v-bind="attrs"
            v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>

        <v-list-item v-if="user.role === 'admin'" :disabled="$route.name === 'users'" @click="nextRoute('users')">
          <v-list-item-icon>
            <v-icon v-text="'mdi-account-multiple'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>Список пользователей</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="user.role === 'admin'" :disabled="$route.name === 'seller'" @click="sellerCreate">
          <v-list-item-icon>
            <v-icon v-text="'mdi-account-arrow-right-outline'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>Настройка данных</v-list-item-title>
        </v-list-item>

        <v-list-item @click="nextRoute('logout')">
          <v-list-item-icon>
            <v-icon v-text="'mdi-logout'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>Выйти из системы</v-list-item-title>
        </v-list-item>

      </v-list>

    </v-menu>
  </v-app-bar>
</template>

<script>
import router from "@/router";
import {companiesService} from "@/services/CompaniesService";

const {authService} = require("~/services/AuthService");

import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      seller: {},
      theme: 'light',
    }
  },
  async created() {
    const user = authService.getUser()

    if (!user.role) {
      await authService.forceLogout()
      await this.$router.push({name: 'auth'})
      return
    }
    this.setUser(user)
    this.theme = localStorage.getItem('theme') || 'light'
    const seller = await companiesService.seller()
    if (!seller.data) return
    this.seller = seller.data

  },
  methods: {
    handleTheme() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark'
      localStorage.setItem('theme', this.theme)
      this.$vuetify.theme.dark = this.theme === 'dark'
    },
    async nextRoute(name) {
      await router.push({name: name})
    },
    async sellerCreate() {
      const response = await companiesService.seller()
      const id = response.data?.Id

      if (id) {
        await router.push({
          name: 'seller',
          params: {id: id},
          replace: true
        })
        return
      }
      await router.push({
        name: 'seller',
        replace: true
      })
    }
  },
}
</script>
